export default {
    RESTAURANT_DETAILS_LOADING: 'RESTAURANT_DETAILS_LOADING',
    RESTAURANT_DETAILS_ERROR: 'RESTAURANT_DETAILS_ERROR',
    RESTAURANT_DETAILS_LOADED: 'RESTAURANT_DETAILS_LOADED',


    RESTAURANT_CAPABILITIES_LOADING: 'RESTAURANT_CAPABILITIES_LOADING',
    RESTAURANT_CAPABILITIES_ERROR: 'RESTAURANT_CAPABILITIES_ERROR',
    RESTAURANT_CAPABILITIES_LOADED: 'RESTAURANT_CAPABILITIES_LOADED',
    RESTAURANT_ALL_CAPABILITIES_LOADED: 'RESTAURANT_ALL_CAPABILITIES_LOADED',
    RESTAURANT_FLAGS_LOADED: 'RESTAURANT_FLAGS_LOADED',


    RESTAURANT_CAPABILITIES_SET_FLAG: 'RESTAURANT_CAPABILITIES_SET_FLAG',
    RESTAURANT_CAPABILITIES_RESET_FLAGS: 'RESTAURANT_CAPABILITIES_RESET_FLAGS',
    RESTAURANT_CAPABILITIES_PERSIST_FLAGS: 'RESTAURANT_CAPABILITIES_PERSIST_FLAGS',

    RESTAURANT_CAPABILITIES_SAVING: 'RESTAURANT_CAPABILITIES_SAVING',
    RESTAURANT_CAPABILITIES_SAVED: 'RESTAURANT_CAPABILITIES_SAVED',
    RESTAURANT_CAPABILITIES_SAVE_ERROR: 'RESTAURANT_CAPABILITIES_SAVE_ERROR',
    RESTAURANT_CAPABILITIES_CLEAR_ERRORS: 'RESTAURANT_CAPABILITIES_CLEAR_ERRORS',
    RESTAURANT_CAPABILITIES_SAVED_CLEAR: 'RESTAURANT_CAPABILITIES_SAVED_CLEAR',

    RESTAURANT_SUBSCRIPTIONS_SELECT_PROVIDER: 'RESTAURANT_SUBSCRIPTIONS_SELECT_PROVIDER',
    RESTAURANT_SUBSCRIPTIONS_SET_METADATA: 'RESTAURANT_SUBSCRIPTIONS_SET_METADATA',
    RESTAURANT_SUBSCRIPTIONS_RESET: 'RESTAURANT_SUBSCRIPTIONS_RESET',


    RESTAURANT_SUBSCRIPTIONS_LOADING: 'RESTAURANT_SUBSCRIPTIONS_LOADING',
    RESTAURANT_SUBSCRIPTIONS_LOADED: 'RESTAURANT_SUBSCRIPTIONS_LOADED',
    RESTAURANT_SUBSCRIPTIONS_LOAD_ERROR: 'RESTAURANT_SUBSCRIPTIONS_LOAD_ERROR',

    SUBSCRIPTIONS_LOADING: 'SUBSCRIPTIONS_LOADING',
    SUBSCRIPTIONS_LOADED: 'SUBSCRIPTIONS_LOADED',
    SUBSCRIPTIONS_LOAD_ERROR: 'SUBSCRIPTIONS_LOAD_ERROR',

    RESTAURANT_SUBSCRIPTIONS_SAVING: 'RESTAURANT_SUBSCRIPTIONS_SAVING',
    RESTAURANT_SUBSCRIPTIONS_SAVED: 'RESTAURANT_SUBSCRIPTIONS_SAVED',
    RESTAURANT_SUBSCRIPTIONS_SAVE_ERROR: 'RESTAURANT_SUBSCRIPTIONS_SAVE_ERROR',

    SET_TENANT: 'SET_TENANT',
    SET_RESTAURANT_ID: 'SET_RESTAURANT_ID',

    SET_ROUTER_PARAMS: 'SET_ROUTER_PARAMS'

};





// WEBPACK FOOTER //
// /src/store/actionTypes.js